import type { Policy } from '@/data/subsidy/policies/interfaces';
import { formatMoney } from '@/utils/format-money';
import { parsePolicyLimits } from '@/utils/parse-policy-limits';

export const refundValueDetail = (policyLimits?: Policy['limits']) => {
  if (!policyLimits)
    return { policyText: null, shouldShowRefundableValue: false };

  const { percentageLimit, amountLimitPerPurchase, hasPercentage, hasPurchaseCap } =
    parsePolicyLimits(policyLimits);

  if (hasPercentage && hasPurchaseCap) {
    return {
      policyText: `${percentageLimit}% do valor pago até ${formatMoney(amountLimitPerPurchase)}.`,
      shouldShowRefundableValue: true,
    };
  }

  if (hasPercentage) {
    return {
      policyText: `${percentageLimit}% do valor pago.`,
      shouldShowRefundableValue: true,
    };
  }

  if (hasPurchaseCap) {
    return {
      policyText: `Até ${formatMoney(amountLimitPerPurchase)}.`,
      shouldShowRefundableValue: true,
    };
  }

  return {
    policyText: 'De acordo com as regras de reembolso de sua empresa.',
    shouldShowRefundableValue: false,
  };
};
